<mat-card class="container-parent">
  <app-custom-header >
    <div title>
      <h1 color="primary">Dashboard</h1>
    </div>
    <div headeractions>
    </div>
  </app-custom-header>
  <mat-card-content class="container-child">
    
  </mat-card-content>
  <mat-card-content>
    <button mat-raised-button color="accent">
        Footer
    </button>
  </mat-card-content>
</mat-card>